import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCategories, selectAllCategories, selectCategoriesLoading } from '../features/categories';
import { AppDispatch } from '../features/store';
import Loader from '../components/Loader';
import CategoriesGrid from '../components/CategoriesGrid';
import './Categories.css';

const Categories: React.FC = () => {
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const categories = useSelector(selectAllCategories);
  const loading = useSelector(selectCategoriesLoading);

  useEffect(() => {
    // Fetch categories when component mounts
    dispatch(getAllCategories());
  }, [dispatch]);

  const handleCategoryClick = (categoryId: string) => {
    navigate(`/products?category=${categoryId}`);
  };

  if (loading) {
    return (
      <div className="categories-page">
        <Loader size="large" text={t('categories.loadingCategories')} />
      </div>
    );
  }

  return (
    <div className="categories-page">
      <div className="container">
        {/* Page Header */}
        <div className="categories-header">
          <h1 className="categories-title">{t('categories.exploreCategories')}</h1>
          <p className="categories-subtitle">
            {t('categories.discoverCategories')}
          </p>
        </div>

        {/* Categories Grid */}
        <CategoriesGrid 
          categories={categories} 
          onCategoryClick={handleCategoryClick}
        />

        {/* Empty State */}
        {!loading && categories.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">📦</div>
            <h3>{t('categories.noCategoriesFound')}</h3>
            <p>{t('categories.checkBackLater')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Categories;

